// @flow

class HelpLink {
  title: string;
  description: ?string;
  url: string;
  isVideo: boolean;

  static parseList(raw?: any): HelpLink[] {
    let list: HelpLink[] = [];
    if (raw && Array.isArray(raw)) {
      for (let item of raw) {
        const process: ?HelpLink = HelpLink.parse(item);
        if (process) {
          list.push(process);
        }
      }
    }
    return list;
  }

  static parse(raw: any): ?HelpLink {
    if (raw) {
      const process = new HelpLink();
      process.copyFrom(raw);
      return process;
    }
  }

  copyFrom(raw: any) {
    this.title = raw.title;
    this.description = raw.description;
    this.url = raw.url;
    this.isVideo = raw.isVideo;
  }
}

export default HelpLink;
